import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { WebRequest } from '@cgn/framework-ui-components/v1';
import { MiniPanel } from '@cgn/framework-ui-components/v2';
import { ASSISTENZA_NON_SUBITO_DISPONIBILE } from '../../Shared/messages';

function getStatoOperatoreDisponibilePerServizio(baseUrl, idServizio) {
  return WebRequest.get(`${baseUrl}/NuovaPratica/OperatoriDisponibili`, { idServizio });
}

export default function AvvisoOperatoriNonDisponibili({ baseUrl, idServizio }) {
  const [operatoriDisponibili, setOperatoriDisponibili] = useState(null);

  useEffect(() => {
    setOperatoriDisponibili(null);
    if (idServizio !== null) {
      getStatoOperatoreDisponibilePerServizio(baseUrl, idServizio)
        .then(setOperatoriDisponibili);
    }
  }, [baseUrl, idServizio]);

  return (
    <MiniPanel
      position="right"
      type={operatoriDisponibili ? 'success' : 'info'}
      message={ASSISTENZA_NON_SUBITO_DISPONIBILE}
    />
  );
}

AvvisoOperatoriNonDisponibili.propTypes = {
  idServizio: PropTypes.number,
  baseUrl: PropTypes.string,
};

AvvisoOperatoriNonDisponibili.defaultProps = {
  baseUrl: '',
  idServizio: null,
};
